import { render, staticRenderFns } from "./TareasView.vue?vue&type=template&id=252f58f2&scoped=true"
import script from "./TareasView.vue?vue&type=script&lang=js"
export * from "./TareasView.vue?vue&type=script&lang=js"
import style0 from "./TareasView.vue?vue&type=style&index=0&id=252f58f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252f58f2",
  null
  
)

export default component.exports